import Console from 'utility/Debug/Console';
import { getCheck24Namespace } from 'utility/Provide/Namespace/getCheck24Namespace';
import {
    Ecommerce,
    EventParam,
    EventParamListGa4,
    PageView,
} from 'utility/Track/types';

import { DataLayerPushModule } from 'types/legacy/dataLayerPush';
import { GlobalNamespace } from 'types/legacy/namespace';

import { GoogleTagManagerEvents } from 'proto/Hotel/Hotel';

import { Impression, ImpressionList, PayloadInterface } from './types';

let dataLayerPush: DataLayerPushModule | undefined = undefined;

/**
 * @deprecated filled with default value, no need anymore, but should be replaced
 */
export const replaceDeprecatedVariant = (
    impressions: ImpressionList
): ImpressionList => {
    impressions.forEach((impression: Impression) => {
        if (impression.variant) {
            impression.variant = impression.variant.replace(
                '#BOOKEDOUTHOTELSPLACEHOLDER#',
                'without_booked_out_hotels'
            );
            impression.variant = impression.variant.replace(
                '#UNLOVEDPLACEHOLDER#',
                ''
            );
        }
    });

    return impressions;
};

export const pushProductClick = (
    tagManagerEvents?: GoogleTagManagerEvents
): void => {
    if (tagManagerEvents?.click) {
        const eventParams = JSON.parse(tagManagerEvents.click);

        if (eventParams.ecommerce?.click?.products) {
            eventParams.ecommerce.click.products = replaceDeprecatedVariant(
                eventParams.ecommerce.click.products
            );
        }

        pushToDataLayer(eventParams);
    }
};

const getDataLayerPush = (): DataLayerPushModule => {
    if (!dataLayerPush) {
        dataLayerPush = (getCheck24Namespace() as GlobalNamespace)?.events
            ?.datalayerPush;
    }
    if (!dataLayerPush) {
        const onNotTracked = (obj: unknown, from?: string) => {
            Console.info(obj, from, 'not tracked');
        };

        return {
            push: (obj: unknown, from?: string) => {
                onNotTracked(obj, from);
            },
            pushVirtualPageView(obj: PageView, from?: string) {
                onNotTracked(obj, from);
            },
            pushSearchListImpressions(obj: Ecommerce, from?: string) {
                onNotTracked(obj, from);
            },
        };
    }

    return dataLayerPush;
};

const log = (payload: PayloadInterface) =>
    Console.info('TRACK-ACTION:', payload);

const logGa4 = (payload: EventParamListGa4) =>
    Console.info('TRACK-GA4-ACTION:', payload);

export const pushToDataLayer = (
    eventParamList: PayloadInterface | EventParamListGa4
) => getDataLayerPush().push(eventParamList);

/**
 * @description eventParams
 * @type category: String;
 * @type action: String;
 * @type label: String;
 */
const trackingEvent = (eventParams?: EventParam) => {
    const payload: PayloadInterface = {
        event: 'event',
        eventCategory: eventParams?.category,
        eventAction: eventParams?.action,
        eventLabel: eventParams?.label,
    };

    log(payload);

    return pushToDataLayer(payload);
};

export default trackingEvent;

export const trackGa4Event = (
    event: string,
    eventParamList?: EventParamListGa4
) => {
    const payload: EventParamListGa4 = {
        event,
        ...eventParamList,
    };

    logGa4(payload);

    return pushToDataLayer(payload);
};

export const promotionEvent = (promotionParams: PayloadInterface) => {
    log(promotionParams);

    return pushToDataLayer(promotionParams);
};

export const trackImpression = (
    eventName: string,
    impressionParams: Record<string, unknown>
) => {
    const payload = {
        event: eventName,
        ecommerce: impressionParams,
    };
    log(payload);

    return pushToDataLayer(payload);
};

export const pushSearchListImpressions = (
    impressions: string | undefined,
    from?: string
) => {
    const obj = impressions ? JSON.parse(impressions) : {};

    if (obj.ecommerce?.impressions) {
        obj.ecommerce.impressions = replaceDeprecatedVariant(
            obj.ecommerce.impressions
        );
    }

    return getDataLayerPush().pushSearchListImpressions(obj, from);
};

export const pushVirtualPageView = (
    pageView: string | undefined,
    from?: string
) =>
    getDataLayerPush().pushVirtualPageView(
        pageView ? JSON.parse(pageView) : {},
        from
    );
